<template>
  <div class="wrapper">
    <div
      v-if="searchParams.enabled"
      class="search"
    >
      <ElInput
        ref="searchInput"
        v-model.trim="query"
        :placeholder="placeholder"
        style="margin-bottom: var(--ps-padding-l);"
        @input="onSearch"
      >
        <template #prefix>
          <PsIcon name="search" />
        </template>
        <template #suffix>
          <PsIcon
            v-if="query.length > 0"
            name="close"
            style="cursor: pointer;"
            @click="query = ''"
          />
        </template>
      </ElInput>
    </div>
    <VirtualTree
      ref="tree"
      :items="items"
      :idField="idField"
      :skipPrepare="true"
      :trackShift="trackShift"
      :showDepth="showDepth"
      :openPadding="padding"
      :searchParams="searchParams"
      :searchQuery="query"
      :sortField="sortField"
    >
      <template #default="{ item, selected, opened }">
        <slot v-bind="{ item, selected, opened }" />
      </template>
      <template #empty>
        <p>{{ emptyText }}</p>
      </template>
    </VirtualTree>
  </div>
</template>

<script setup lang="ts">
/* TODO: Удалить строки с игнорированием TS в задаче PUB-4409 (Исправить ошибки типизации) */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ref, useTemplateRef, onMounted } from 'vue'
import { ElInput } from 'element-plus'
import PsIcon from '@/ContextTab/components/UI/PsIcon.vue'
import VirtualTree from '@/ContextTab/components/UI/VirtualTree/VirtualTree.vue'
import type { TreeSearchParams } from './useTreeSearch'


const props = withDefaults(
  defineProps<{
    items: any
    searchParams: TreeSearchParams
    emptyText?: string
    trackShift?: number
    showDepth?: number
    padding?: number
    idField?: string
    sortField?: string
    placeholder?: string
  }>(),
  {
    emptyText: 'Ничего не найдено',
    padding: 20,
    trackShift: 1,
    showDepth: 1,
    idField: 'id',
    sortField: 'pos',
    placeholder: 'Поиск по кодам',
  },
)

const searchInput = useTemplateRef('searchInput')

const tree = useTemplateRef('tree')

const query = ref(props.searchParams.initialQuery)

const onSearch = (updated: string) => {
  query.value = updated
}

const scrollToTop = () => {
  tree.value?.scrollToTop()
}

onMounted(() => {
  searchInput.value?.focus()
})

defineExpose({
  scrollToTop,
})
</script>

<style scoped>
.wrapper {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
